/** @jsx jsx */

import React, { Fragment as _, useContext, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import { Box } from 'theme-ui';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { useSelector } from 'react-redux';

const { lPink, lGrey2 } = colors;

const EditCardWrapper = ({ id }) => {
  // , selected
  // children

  const focusedNodeId = useSelector((state: any) => state.focusedNodeId);
  const selected = focusedNodeId === id;

  const gutter = 9;

  return (
    <div
      css={css({
        position: 'absolute',
        left: gutter,
        top: gutter,
        width: `calc(100% + ${-(gutter * 2)}px)`,
        height: `calc(100% + ${-(gutter * 2)}px)`,
        // margin: gutter,

        // borderRadius: `${selected ? '24px' : 0} 24px 24px 24px`,
        boxShadow: `${selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'}`,
        ...(!selected && {
          cursor: 'pointer',

          '&:hover': {
            boxShadow: `0 0 0 1px ${lPink}`,
          },
        }),
        transition: 'box-shadow 0.2s, border-radius 0.2s',
      })}
      onClick={e => {
        e.stopPropagation();

        if (selected) return;

        // console.log({ mediaParentId });

        setCurrentBlock({ id });
      }}
    >
      {/* {children} */}

      {!selected && (
        <EditMarker
          style={{
            // left: 0,
            // transform: 'scaleX(-1)',
            right: 0,
            zIndex: '2147483647',
          }}
        />
      )}
    </div>
  );
};

export default EditCardWrapper;
